<template>
  <br>
  <div class="container">
    <button class="btn btn-primary btn-sm" @click="generatePDF()">下載 PDF</button>
    <br>
    <br>
    <div class="table-responsive" ref="content">
      <table class="detailtable table table-bordered" style="text-align: center;width:100% !important">
      <thead>
        <tr>
            <th colspan="16" style="text-align: left;">
              <h3><b>精準運動轉介處方運動項目分析結果</b>
              </h3>
            </th>
          </tr>
          <tr>
            <th colspan="16" style="text-align: left;">基本資料</th>
          </tr>
          <tr>
            <th colspan="2">填答日期</th>
            <td colspan="2">{{ answerDate }}</td>
            <th colspan="2">姓名:</th>
            <td colspan="2">{{ name }}</td>
            <th colspan="2">年齡</th>
            <td colspan="2">{{ age }}</td>
            <th colspan="2">性別:</th>
            <td colspan="2" v-if="gender == 'female'">女</td>
            <td colspan="2" v-else-if="gender == 'male'">男</td>
            <td colspan="2" v-else>未知</td>
          </tr>
         
        <tr>
         <th>活動</th>
         <th>MET</th>
         <th>大卡/小時</th>
         <th>單獨、配對或團體</th>
         <th>室內或戶外</th>
         <th>水上或陸上</th>
         <th>休閒、競賽或健身</th>
         <th>自主性或制度化</th>
         <th>接觸性或非接觸性</th>
         <th>受傷的風險</th>
         <th style="color:red;">可否精準控制</th>
         <th>需要器材</th>
         <!-- <th>裝備、場地</th> -->
         <th>體能效益類別</th>
         <th>花費時間</th>
         <th style="color:red;">衝擊性或非衝擊性</th>
         <th style="color:red;">技巧性或非技巧性</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(activity, index) in filteredActivities" :key="index">
          <td>{{ activity.activity }}</td>
          <td>{{ activity.MET }}</td>
          <td>{{ activity.calories_per_hour }}</td>
          <td>{{ activity.grouping }}</td>
          <td>{{ activity.location }}</td>
          <td>{{ activity.terrain }}</td>
          <td>{{ activity.type }}</td>
          <td>{{ activity.autonomy }}</td>
          <td>{{ activity.contact_level }}</td>
          <td>{{ activity.injury_risk }}</td>
          <td style="color:red;">{{ activity.control_precision }}</td>
          <td>{{ activity.equipment_needed }}</td>
          <!-- <td>{{ activity.equipment_details }}</td> -->
          <td>{{ activity.fitness_benefit }}</td>
          <td>{{ activity.time_spent }}</td>
          <td style="color:red;">{{ activity.impact_level }}</td>
          <td style="color:red;">{{ activity.skill_level }}</td>
        </tr>
        <!-- 如果 filteredActivities 是空的，顯示查無符合條件結果 -->
        <tr v-if="filteredActivities.length === 0">
          <td colspan="16">查無符合條件結果</td>
        </tr>
      </tbody>
    </table>
    </div>
    <table class="detailtable table " style="width:100% !important">
        <tbody>
          <tr>
            <th colspan="7"><p>填單者編號:{{ userId }}</p></th>
            <th colspan="3"><button class="btn btn-primary btn-sm" @click="generatePDF()">下載 PDF</button></th>
            <th colspan="3"><button @click="goHomePage()" class="btn btn-primary btn-sm">回清單</button></th>
            <th colspan="3"><button @click="isShowUserFormData = !isShowUserFormData" class="btn btn-primary btn-sm">檢視問卷內容</button></th>
          </tr>
        </tbody>
      </table>
    <div v-if="isShowUserFormData" class="userForm">
      <hr>
      <p>填單日期時間: {{ answerDateTime }}</p>
      <div>
      <h3 class="mb-4">基本資料 <span style="font-size: 14px;color: gray;">Page 1</span></h3>
      <div class="row">
        <div class="col-md-6">
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="name" v-model="formData.name" :disabled="isReadOnly" />
            <label class="floating-label" for="name">姓名</label>
          </div>
          <div class="form-floating mb-3">
            <select class="form-control" id="gender" v-model="formData.gender" :disabled="isReadOnly" >
              <option value="male">男</option>
              <option value="female">女</option>
            </select>
            <label class="floating-label" for="gender">性別</label>
          </div>
          <div class="form-floating mb-3">
            <input type="text" class="form-control" id="age" v-model="formData.age" :disabled="isReadOnly" />
            <label class="floating-label" for="age">年齡</label>
          </div>
        </div>
      </div>
    </div>
    <div>
      <h3 class="mb-4">運動喜好調查 <span style="font-size: 14px;color: gray;">Page 2</span></h3>
      <label class="form-label">你喜歡什麼特性的運動？</label>
      <div class="mb-3">
        <div class="mb-2">
          <p>甲：</p>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.grouping" value="單獨" v-bind:disabled="isReadOnly" /> 單獨
          </label>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.grouping" value="團體" v-bind:disabled="isReadOnly" /> 有伴
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.grouping" value="皆可" v-bind:disabled="isReadOnly" /> 皆可
          </label>
        </div>
        <div class="mb-2">
          <p>乙：</p>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.location" value="室內" v-bind:disabled="isReadOnly" /> 室內
          </label>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.location" value="戶外" v-bind:disabled="isReadOnly" /> 戶外
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.location" value="皆可" v-bind:disabled="isReadOnly" /> 皆可
          </label>
        </div>
        <div class="mb-2">
          <p>丙：</p>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.autonomy" value="制度化" v-bind:disabled="isReadOnly" /> 結構性的
          </label>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.autonomy" value="自主性" v-bind:disabled="isReadOnly" /> 自由性的
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.autonomy" value="皆可" v-bind:disabled="isReadOnly" /> 皆可
          </label>
        </div>
        <div class="mb-2">
          <p>丁：</p>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.type" value="競賽" v-bind:disabled="isReadOnly" /> 競賽
          </label>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.type" value="休閒" v-bind:disabled="isReadOnly" /> 非競賽
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.type" value="皆可" v-bind:disabled="isReadOnly" /> 皆可
          </label>
        </div>
      </div>
      <br>
    </div>
    <div>
      <h3 class="mb-4">三、 運動資源調查 <span style="font-size: 14px;color: gray;">Page 3</span></h3>
      <div class="mb-3">
        <div class="mb-3">
          <label class="form-label">每週能運動幾天？</label>
          <div class="btn-group" role="group" style="padding-left: 55px;">
            <button v-for="option in everyWeekSportDayOptions" :key="option.value" type="button"
              class="btn btn-outline-info" :class="{ 'btn-info': everyWeekSportDay === option.value }"
              @click="formData.everyWeekSportDay = option.value">
              <span style="color: rgb(69, 69, 69);">{{ option.label }}</span>
            </button>
          </div>
        </div>
        <div class="mb-2">
          <p>有多少時間運動?</p>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.time_spent" value="很多" v-bind:disabled="isReadOnly" /> 120分鐘以上
          </label>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.time_spent" value="很多2" v-bind:disabled="isReadOnly" /> 90至120分鐘
          </label>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.time_spent" value="多" v-bind:disabled="isReadOnly" /> 60至90分鐘
          </label>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.time_spent" value="多2" v-bind:disabled="isReadOnly" /> 30至60分鐘
          </label>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.time_spent" value="少" v-bind:disabled="isReadOnly" /> 小於30分鐘
          </label>
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input" v-model="formData.check_time_spent" value="可調整" v-bind:disabled="isReadOnly" /> 可調整
          </label>
        </div>
        <div class="mb-2">
          <p>你住家與工作場所距離運動場?</p>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.sportsDistance" value="很近" v-bind:disabled="isReadOnly" /> 很近
          </label>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.sportsDistance" value="很遠" v-bind:disabled="isReadOnly" /> 很遠
          </label>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.sportsDistance" value="很不方便" v-bind:disabled="isReadOnly" /> 很不方便
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.sportsDistance" value="沒有運動場所"  v-bind:disabled="isReadOnly" /> 沒有運動場所
          </label>
        </div>
        <div class="mb-2">
          <p>每周願意花多少錢運動?</p>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.sportsMoney" value="2000以上" v-bind:disabled="isReadOnly" /> 2000以上
          </label>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.sportsMoney" value="1000至2000" v-bind:disabled="isReadOnly" /> 1000至2000
          </label>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.sportsMoney" value="500至1000" v-bind:disabled="isReadOnly" /> 500至1000
          </label>
          <label class="form-check-label" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" v-model="formData.sportsMoney" value="500至100" v-bind:disabled="isReadOnly" /> 500至100
          </label>
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input" v-model="formData.check_sportsMoney" value="小於100" v-bind:disabled="isReadOnly" /> 小於100
          </label>
        </div>
      </div>
      <br>
    </div>
    <div>
      <h3 class="mb-4">四、 運動成效期待調查 <span style="font-size: 14px;color: gray;">Page 4</span></h3>
      <div class="mb-3">
        <div class="mb-2">
          <p>預期降低疾病風險：</p>
          <label class="form-check-label" style="margin-right: 50px;">
            <input type="radio" class="form-check-input" v-model="formData.disease" value="是" v-bind:disabled="isReadOnly" /> 是
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.disease" value="否" v-bind:disabled="isReadOnly" /> 否
          </label>
        </div>
        <div class="mb-2">
          <p>預期降低血壓：</p>
          <label class="form-check-label" style="margin-right: 50px;">
            <input type="radio" class="form-check-input" v-model="formData.blood" value="是" v-bind:disabled="isReadOnly" /> 是
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.blood" value="否" v-bind:disabled="isReadOnly" /> 否
          </label>
        </div>
        <div class="mb-2">
          <p>預期增強肌力：</p>
          <label class="form-check-label" style="margin-right: 50px;">
            <input type="radio" class="form-check-input" v-model="formData.muscle" value="是" v-bind:disabled="isReadOnly" /> 是
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.muscle" value="否" v-bind:disabled="isReadOnly" /> 否
          </label>
        </div>
      </div>
      <br>
    </div>
    <div>
      <h3 class="mb-4">運動成效期待調查 <span style="font-size: 14px;color: gray;">Page 5</span></h3>
      <div class="mb-3">
        <div class="mb-2">
          <p>預期減重：</p>
          <label class="form-check-label" style="margin-right: 50px;">
            <input type="radio" class="form-check-input" v-model="formData.loseWeight" value="是" v-bind:disabled="isReadOnly" /> 是
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.loseWeight" value="否" v-bind:disabled="isReadOnly" /> 否
          </label>
        </div>
        <div class="mb-2">
          <p>預期改善日常活動的身體功能：</p>
          <label class="form-check-label" style="margin-right: 50px;">
            <input type="radio" class="form-check-input" v-model="formData.bodyFunctions" value="是" v-bind:disabled="isReadOnly" /> 是
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.bodyFunctions" value="否" v-bind:disabled="isReadOnly" /> 否
          </label>
        </div>
        <div class="mb-2">
          <p>預期感覺良好：</p>
          <label class="form-check-label" style="margin-right: 50px;">
            <input type="radio" class="form-check-input" v-model="formData.feelGood" value="是" v-bind:disabled="isReadOnly" /> 是
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.feelGood" value="否" v-bind:disabled="isReadOnly" /> 否
          </label>
        </div>
        <div class="mb-2">
          <p>預期外表比較好看：</p>
          <label class="form-check-label" style="margin-right: 50px;">
            <input type="radio" class="form-check-input" v-model="formData.looksBetter" value="是" v-bind:disabled="isReadOnly" /> 是
          </label>
          <label class="form-check-label">
            <input type="radio" class="form-check-input" v-model="formData.looksBetter" value="否" v-bind:disabled="isReadOnly" /> 否
          </label>
        </div>
        <br>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
export default {
  name: 'DetailPageRecommed',
  data() {
    return {
      isDev: window.VUE_APP_Dev,
      PK: '',
      SK: '',
      answerDateTime:'',
      answerDate: this.getCurrentDate(),
      name: '',
      age: null,
      gender: '',
      stageValue: '',
      intensity: '',
      habitstageValue: '',
      exerciseValue: 0,
      formData: {},
      userLoginType: '',
      userId: '',
      filteredActivities: [],  // 儲存篩選後的數據
      isShowUserFormData : false,
      isReadOnly: true
    };
  },
  beforeMount() {
    this.userLoginType = localStorage.getItem("userLoginType");
    const linecode = localStorage.getItem("linecode");
   
    if (this.isDev != '1') {
      if (!linecode) {
        this.$router.push({ name: "HomePage" });
      }
    }
  },
  created() {

    if (this.$route.query.PK) {
      this.PK = this.$route.query.PK;
    }
    if (this.$route.query.SK) {
      this.SK = this.$route.query.SK;
    }
    this.fetchData();

  },
  mounted() {
    this.answerDateTime = this.convertTimestampToDate();
  },
  methods: {
    async generatePDF() {
      const element = this.$refs.content;
      const canvas = await html2canvas(element, { scrollY: -window.scrollY });
      const imgData = canvas.toDataURL('image/png');

      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'px',
        format: 'a4'
      });

      const margin = 10; // 边距
      const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * margin;
      const pdfHeight = pdf.internal.pageSize.getHeight() - 2 * margin;
      const imgProps = pdf.getImageProperties(imgData);
      const scaledWidth = pdfWidth;
      const scaledHeight = imgProps.height * scaledWidth / imgProps.width;
      let position = 0;

      // 添加第一页
      pdf.addImage(imgData, 'PNG', margin, margin, scaledWidth, Math.min(scaledHeight, pdfHeight));
      position += pdfHeight;

      // 检查是否需要添加新页面
      if (position < scaledHeight) {
        while (position < scaledHeight) {
          // 计算剩余内容高度
          const remainingContentHeight = scaledHeight - position;
          // 如果剩余内容高度大于一页，则添加新页面
          if (remainingContentHeight > pdfHeight) {
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', margin, margin - position, scaledWidth, Math.min(remainingContentHeight, pdfHeight));
          }
          position += pdfHeight;
        }
      }

      pdf.save('recommed.pdf');
    },
    convertTimestampToDate() {
      return new Date(this.SK * 1000).toLocaleString();
    },
    goHomePage() {
      this.$router.push({ name: "HomePage" });
    },
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    },
    fetchData() {
      // 使用axios呼叫API，傳入PK和SK作為參數
      axios
        .get('https://147isrgvqd.execute-api.ap-northeast-1.amazonaws.com/get_data', {
          params: {
            PK: this.PK,
            SK: this.SK,
          },
        })
        .then((response) => {
          const data = response.data;
          let fondateTmp = data.form_data;
          if (data.item_recommendFormData ){
            fondateTmp = data.item_recommendFormData;
          }

          // 解析result_data並將數據綁定到頁面上
          this.formData = fondateTmp;
          if (this.formData.time_spent === '很多(可調整)' || this.formData.time_spent === '很多2') {
            this.formData.time_spent = '很多';
          }
          else if (this.formData.time_spent === '多(可調整)' || this.formData.time_spent === '多2') {
            this.formData.time_spent = '多';
          }
          else if (this.formData.time_spent === '少(可調整)') {
            this.formData.time_spent = '少';
          }
          else if (this.formData.time_spent === '很少(可調整)') {
            this.formData.time_spent = '很少';
          }
         
          this.answerDate = fondateTmp.answerDate;
          this.name = fondateTmp.name;
          this.age = fondateTmp.age;
          this.gender = fondateTmp.gender;
          const parts = data.PK.split("_");
          this.userId = parts[1];     // 取得"user123"
           // 檢查 resultData 是否存在於 result_data 中
          if (data.result_data && data.result_data.filteredActivities) {
            // 如果 resultData 存在，直接使用
            this.filteredActivities = data.result_data.filteredActivities;
          } 
          else if (data.result_data && data.result_data.resultData) {
            // 如果 resultData 存在，直接使用
            this.filteredActivities = data.result_data.resultData;
          } else if (data.result_data) {
            // 如果 resultData 不存在，但 result_data 存在，將 result_data 轉成 array
            this.filteredActivities = [data.result_data];
          } else {
            // 如果 result_data 也不存在，設置一個空的 array
            this.filteredActivities = [];
          }
          

        })
        .catch((error) => {
          console.error(error);
        });
    },

  },
};
</script>

<style>
@media (max-width: 768px) {
  table {
    width: 100%;
  }

  .table-responsive {
    overflow-x: auto;
  }
}

/* 在這裡放置您的 CSS 样式 */
body {
  font-family: 'Arial', sans-serif;
  background-color: #EFEDE6 !important;
  /* margin: 20px; */
}

table {
  /* width: 200mm !important; */
  /* 設定寬度為200mm */
  background-color: #EFEDE6 !important;

  border-collapse: collapse;
  margin-bottom: 20px;
}

.info-box {
  padding: 10px;
  margin-bottom: 20px;
}

.detailtable {
  width: 100%;
  /* background-color: #EFEDE6; */
  border-collapse: collapse;
  margin-bottom: 20px;
  border:1px #cccccc solid!important;
}

.detailtable th,
.detailtable td {
  padding: 10px;
  text-align: center;
  border:1px #cccccc solid!important;

}

.detailtable th {
  font-weight: bold;
}

.feedback-header {
  font-size: 1.1em;
  font-weight: 800;
  margin-bottom: 10px;
}

.bd-code-snippet {
  /* width: 200mm !important; */
  border-width: 1px;
  border-radius: var(--bs-border-radius);
  border: solid var(--bs-border-color);
}

.custom-textarea {
  width: 100%;
  border: 1;
}
input[type="range"]::-webkit-slider-runnable-track {
  background: #CC785C;
  height: 0.5rem;
}

input[type="range"]::-webkit-slider-thumb {
  background-color: #343333;
}

.form-floating>.form-control:focus~label::after,
.form-floating>.form-control:not(:placeholder-shown)~label::after,
.form-floating>.form-control-plaintext~label::after,
.form-floating>.form-select~label::after {
  background-color: transparent !important;
}

.floating-label {
  font-size: 18px !important;
  background-color: transparent !important;
}

.userForm input,
.userForm textarea {
  pointer-events: none;
}

.userForm input[type="radio"],
.userForm input[type="checkbox"] {
  pointer-events: none;
}
</style>